/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Receipt_Detail_Alloc_Amount_ColInputs */

const vi_receipt_detail_alloc_amount_col = /** @type {(inputs: Receipt_Detail_Alloc_Amount_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số tiền`)
};

/**

* @param {Receipt_Detail_Alloc_Amount_ColInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const receipt_detail_alloc_amount_col = /** @type {((inputs?: Receipt_Detail_Alloc_Amount_ColInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_Detail_Alloc_Amount_ColInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_receipt_detail_alloc_amount_col(inputs)
});